












































































import Vue from "vue";

// Vuex
import { mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

// Vue components
import ScheduleConfigurationComponent from "./ScheduleConfigurationComponent.vue";

// Model
import { SaveInstallationsScheduleConfigurationRequestData } from "@/model/communication/scheduleConfiguration/SaveInstallationsScheduleConfigurationRequestData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { InstallationScheduleConfiguration } from "@/model/data/scheduleSettings/InstallationScheduleSettings";
import { ScheduleConfiguration } from "@/model/data/scheduleSettings/ScheduleConfiguration";
import { ScheduleFrequencyEnum } from "@/model/data/scheduleSettings/ScheduleFrequencyEnum";
import { ScheduleTypeEnum } from "@/model/data/scheduleSettings/ScheduleTypeEnum";
import { DayOfWeek } from "@/model/data/scheduleSettings/DayOfWeek";
import { FetchInstallationsScheduleConfigurationRequestData } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationRequestData";
import { FetchInstallationsScheduleConfigurationCommand } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationCommand";
import { FetchInstallationsScheduleConfigurationResponse } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationResponse";
import { LicenseData } from "@/model/data/License/LicenseData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { SaveInstallationsScheduleConfigurationCommand } from "@/model/communication/scheduleConfiguration/SaveInstallationsScheduleConfigurationCommand";

export default Vue.extend({
    components: {
        ScheduleConfigurationComponent,
    },
    data() {
        return {
            isInstallationsScheduleSaving: false,
            currentSchedule: new ScheduleConfiguration(),
            loading: false,
            ScheduleFrequencyEnum,

            availableFrequencyOptions: [
                {
                    text: this.$t("common.notSet"),
                    value: ScheduleFrequencyEnum.NotSet,
                },
                {
                    text: this.$t("scheduleConfiguration.daily"),
                    value: ScheduleFrequencyEnum.Daily,
                },
                {
                    text: this.$t("scheduleConfiguration.weekly"),
                    value: ScheduleFrequencyEnum.Weekly,
                },
                {
                    text: this.$t("scheduleConfiguration.monthly"),
                    value: ScheduleFrequencyEnum.Monthly,
                },
            ],

            availableDaysOFWeekOptions: [
                {
                    text: this.$t("common.dayOfWeek.monday"),
                    value: DayOfWeek.Monday,
                },
                {
                    text: this.$t("common.dayOfWeek.tuesday"),
                    value: DayOfWeek.Tuesday,
                },
                {
                    text: this.$t("common.dayOfWeek.wednesday"),
                    value: DayOfWeek.Wednesday,
                },
                {
                    text: this.$t("common.dayOfWeek.thursday"),
                    value: DayOfWeek.Thursday,
                },
                {
                    text: this.$t("common.dayOfWeek.friday"),
                    value: DayOfWeek.Friday,
                },
                {
                    text: this.$t("common.dayOfWeek.saturday"),
                    value: DayOfWeek.Saturday,
                },
                {
                    text: this.$t("common.dayOfWeek.sunday"),
                    value: DayOfWeek.Sunday,
                },
            ],

            availableMonthOccurenceOptions: [
                {
                    text: this.$t("common.cardinal.first"),
                    value: 0,
                },
                {
                    text: this.$t("common.cardinal.second"),
                    value: 1,
                },
                {
                    text: this.$t("common.cardinal.third"),
                    value: 2,
                },
                {
                    text: this.$t("common.cardinal.fourth"),
                    value: 3,
                },
                {
                    text: this.$t("common.cardinal.last"),
                    value: 4,
                },
            ],
        };
    },
    computed: {
        ...mapState({
            licenseData: (state: RootState): any => state.license.licenseModules,
            authUser: (state: RootState) => state.authMod.currentUser,
        }),
        ...mapGetters(["userTimeFormat", "authUserHasPrivilege"]),
        availableScheduleTypeOptions() {
            let ret = [];

            if ((this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement)) {
                if (this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement))
                    ret.push({
                        text: this.$t("scheduleConfiguration.updateSettings"),
                        value: ScheduleTypeEnum.Update,
                    });

                if (this.authUserHasPrivilege(ClientPrivileges.DownloadLogs))
                    ret.push({
                        text: this.$t("scheduleConfiguration.logDownload"),
                        value: ScheduleTypeEnum.Logs,
                    });
            }

            if ((this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.SecurityManagement)) {
                if (this.authUserHasPrivilege(ClientPrivileges.SecurityManagement) || this.authUserHasPrivilege(ClientPrivileges.SecurityScheduleWrite))
                    ret.push({
                        text: this.$t("scheduleConfiguration.securitySettings"),
                        value: ScheduleTypeEnum.Config,
                    });
            }

            if ((this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.SecurityManagement)) {
                if (this.authUserHasPrivilege(ClientPrivileges.CaosConfigurationManagement))
                    ret.push({
                        text: this.$t("scheduleConfiguration.caosConfigurationBackup"),
                        value: ScheduleTypeEnum.CaosConfigurationBackup,
                    });
            }
            return ret;
        },
    },
    props: {
        installations: Array as () => InstallationScheduleConfiguration[],
        hideCancel: {
            type: Boolean,
            default: false,
        },
        initialSchedule: {
            type: Number as () => ScheduleTypeEnum,
        },
    },
    watch: {
        installations: {
            handler(newValue, oldValue) {
                if (newValue == null || newValue == undefined || newValue.length == 0) return;
                if (this.initialSchedule) this.currentSchedule.scheduleType = this.initialSchedule;
                else {
                    if (this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement)) this.currentSchedule.scheduleType = ScheduleTypeEnum.Update;
                    else if (this.authUserHasPrivilege(ClientPrivileges.DownloadLogs)) this.currentSchedule.scheduleType = ScheduleTypeEnum.Logs;
                    else if (this.authUserHasPrivilege(ClientPrivileges.SecurityManagement)) this.currentSchedule.scheduleType = ScheduleTypeEnum.Config;
                    else if (this.authUserHasPrivilege(ClientPrivileges.CaosConfigurationManagement)) this.currentSchedule.scheduleType = ScheduleTypeEnum.CaosConfigurationBackup;
                }

                if (oldValue == null || oldValue == undefined || oldValue.length == 0 || (newValue.length && oldValue.length && oldValue[0] != newValue[0])) {
                    this.preselectSchedule();
                }
            },
            immediate: true,
        },
    },
    methods: {
        async preselectSchedule() {
            let existingsSchedule = null;
            if (
                (this.installations[0] as InstallationScheduleConfiguration).schedulesConfigurations != null &&
                (this.installations[0] as InstallationScheduleConfiguration).schedulesConfigurations.filter((s) => s.scheduleType == this.currentSchedule.scheduleType).length
            ) {
                existingsSchedule = (this.installations[0] as InstallationScheduleConfiguration).schedulesConfigurations.filter(
                    (s) => s.scheduleType == this.currentSchedule.scheduleType
                )[0];
            } // provo a richiedere la configurazione della prima installazione per coerenza con la pagina di schedule
            else {
                try {
                    let reqData: FetchInstallationsScheduleConfigurationRequestData = new FetchInstallationsScheduleConfigurationRequestData();
                    reqData.installationNames = [this.installations[0].name];
                    reqData.queryLimit = 1;

                    this.loading = true;
                    let res: FetchInstallationsScheduleConfigurationResponse = await new FetchInstallationsScheduleConfigurationCommand(reqData).execute();
                    this.loading = false;
                    if (res.responseStatus == ApiResponseStatusEnum.Success && res.installationsList != null && res.installationsList.length > 0) {
                        let installationConfiguration: InstallationScheduleConfiguration = res.installationsList[0] as InstallationScheduleConfiguration;

                        if (
                            installationConfiguration.schedulesConfigurations != null &&
                            installationConfiguration.schedulesConfigurations.filter((s) => s.scheduleType == this.currentSchedule.scheduleType).length
                        )
                            existingsSchedule = installationConfiguration.schedulesConfigurations.filter((s) => s.scheduleType == this.currentSchedule.scheduleType)[0];
                    }
                } catch (e) {
                    this.loading = false;
                    console.error("Exception: ", e);
                }
            }
            if (existingsSchedule) {
                this.currentSchedule.frequency = existingsSchedule.frequency;
                this.currentSchedule.time = existingsSchedule.time;
                this.currentSchedule.days = existingsSchedule.days;
                this.currentSchedule.monthOccurence = existingsSchedule.monthOccurence;
            } else {
                this.currentSchedule.frequency = ScheduleFrequencyEnum.NotSet;
                this.currentSchedule.time = null;
                this.currentSchedule.days = DayOfWeek.Monday;
                this.currentSchedule.monthOccurence = null;
            }
        },
        async save() {
            let reqData: SaveInstallationsScheduleConfigurationRequestData = new SaveInstallationsScheduleConfigurationRequestData();
            reqData.installationNameList = this.installations.map((c) => c.name);
            reqData.scheduleConfiguration = this.currentSchedule;

            this.isInstallationsScheduleSaving = true;
            let res = await new SaveInstallationsScheduleConfigurationCommand(reqData).execute();
            this.isInstallationsScheduleSaving = false;
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.$emit("close", { forceRefresh: true });
            }
            this.$emit("data-reload");
        },
        onCancelClick() {
            this.$emit("close", { forceRefresh: false });
        },
    },
});
